module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAXCAYAAADk3wSdAAABQ0lEQVQ4ja3VP0tbURgH4Cc3AVHwC9TZbC6SJeA3CAi3uF5nEbcuHYpFv4OIi6ABoUONARdxEEcXP4CLta0OLh0EF7mtw1VILrk5yW1+4/nz8MJ5zzmV6PBYIPNYwgJqSHPzU+imSXz2PlALgF/xCbOBdX8RRCNcvlU4Sh7zmwfl2xjgwIryaWKlLFiEbvwPWIQ2SziVEDpdAu078EHoXQn0Twj9XgLthNAdWTOPmoM0iW9D6DM+jgj+xHp+sKj5u1jFvyHgNRppEj/nJ4bd/TYusIYGPuAFNzjHftHG0IPyG18Ca0ZGm1hGHXOYQfVt7kXWQve4qrY7J2kS/+rdXMm9py1sY3HM4tr4nCbxA/0HtYfTEiAk+FFtd1q9lW5hswQ2KPVI9l1MCoSjyASeulwakexwJpoadhHLWmacO1/kPb0CF2o+spMujzcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bgname.png
// module id = ya0c
// module chunks = 1